var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemRedditComment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Reddit comment bubble icon")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12 2C5.376 2 0 6.296 0 11.6c0 3.036 1.704 5.736 4.356 7.476-.384 1.416-1.272 3.132-3.036 4.164.096.036 3.096-.12 5.436-1.68.888.204 1.848.324 2.844.324 6.624 0 12-4.296 12-9.6S18.624 2 12 2"
})));
export default SvgGemRedditComment;